import React from 'react';
import { MessageSquare, Mail, Phone, Clock, CheckCircle, XCircle } from 'lucide-react';

const SupportPanel = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-foreground">Soporte</h1>
        <div className="flex items-center space-x-2">
          <select className="border border-border rounded-lg bg-secondary/30 px-3 py-2">
            <option>Todos los tickets</option>
            <option>Sin resolver</option>
            <option>En progreso</option>
            <option>Resueltos</option>
          </select>
          <button className="px-4 py-2 bg-accent text-white rounded-lg hover:bg-accent/90">
            Exportar
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="dark-card p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-foreground/70">Tickets Abiertos</p>
              <h3 className="text-2xl font-bold text-foreground">23</h3>
            </div>
            <MessageSquare className="h-8 w-8 text-accent" />
          </div>
          <div className="mt-4">
            <div className="flex items-center">
              <Clock className="h-4 w-4 text-yellow-500 mr-1" />
              <span className="text-sm text-yellow-500">5 necesitan atención urgente</span>
            </div>
          </div>
        </div>

        <div className="dark-card p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-foreground/70">Tiempo Promedio de Respuesta</p>
              <h3 className="text-2xl font-bold text-foreground">2.5h</h3>
            </div>
            <Clock className="h-8 w-8 text-accent" />
          </div>
          <div className="mt-4">
            <div className="flex items-center">
              <CheckCircle className="h-4 w-4 text-green-500 mr-1" />
              <span className="text-sm text-green-500">Dentro del objetivo de 3h</span>
            </div>
          </div>
        </div>

        <div className="dark-card p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-foreground/70">Satisfacción del Cliente</p>
              <h3 className="text-2xl font-bold text-foreground">4.8/5</h3>
            </div>
            <CheckCircle className="h-8 w-8 text-accent" />
          </div>
          <div className="mt-4">
            <div className="flex items-center">
              <CheckCircle className="h-4 w-4 text-green-500 mr-1" />
              <span className="text-sm text-green-500">98% de tickets resueltos</span>
            </div>
          </div>
        </div>
      </div>

      <div className="dark-card overflow-hidden">
        <div className="p-6">
          <h2 className="text-lg font-medium text-foreground mb-4">Tickets Recientes</h2>
          <div className="space-y-4">
            {[
              {
                id: 'TK-001',
                user: 'Ana García',
                subject: 'Problema con el acceso al curso',
                status: 'pending',
                priority: 'high',
                created: '10/05/2025 15:30',
                lastUpdate: 'Hace 1 hora'
              },
              {
                id: 'TK-002',
                user: 'Carlos Martínez',
                subject: 'Error en la generación del certificado',
                status: 'in-progress',
                priority: 'medium',
                created: '10/05/2025 14:20',
                lastUpdate: 'Hace 2 horas'
              },
              {
                id: 'TK-003',
                user: 'Laura Sánchez',
                subject: 'Consulta sobre facturación',
                status: 'resolved',
                priority: 'low',
                created: '10/05/2025 12:15',
                lastUpdate: 'Hace 4 horas'
              }
            ].map((ticket) => (
              <div key={ticket.id} className="border border-border rounded-lg p-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div className={`h-2 w-2 rounded-full ${
                      ticket.priority === 'high' ? 'bg-red-500' :
                      ticket.priority === 'medium' ? 'bg-yellow-500' :
                      'bg-green-500'
                    }`}></div>
                    <span className="ml-2 text-sm font-medium text-foreground">{ticket.id}</span>
                  </div>
                  <div className={`px-2 py-1 rounded-full text-xs font-medium ${
                    ticket.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                    ticket.status === 'in-progress' ? 'bg-blue-100 text-blue-800' :
                    'bg-green-100 text-green-800'
                  }`}>
                    {ticket.status === 'pending' ? 'Pendiente' :
                     ticket.status === 'in-progress' ? 'En Progreso' :
                     'Resuelto'}
                  </div>
                </div>
                <div className="mt-2">
                  <p className="text-sm font-medium text-foreground">{ticket.subject}</p>
                  <p className="text-xs text-foreground/70">Por {ticket.user}</p>
                </div>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground/70">
                  <span>Creado: {ticket.created}</span>
                  <span>Última actualización: {ticket.lastUpdate}</span>
                </div>
                <div className="mt-4 flex justify-end space-x-2">
                  <button className="px-3 py-1 text-xs font-medium text-accent hover:text-accent/90">
                    Ver detalles
                  </button>
                  <button className="px-3 py-1 text-xs font-medium text-green-600 hover:text-green-700">
                    Responder
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportPanel;